import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import BottomNavigation from './BottomNavigation';
import StorySlideshow from './StorySlideshow';
import storiesData from '../story/stories.json';
import timelineData from '../story/the-missing-hour/timeline.json';

// Story progression data removed - now handled by StorySlideshow component

function Home() {
  const navigate = useNavigate();
  const [showRecap, setShowRecap] = useState(false);
  const [playerProgress, setPlayerProgress] = useState({
    currentDay: 0,
    completionPercentage: 0,
    totalDays: 0,
    currentStatus: 'Case Opened'
  });

  // Get selected story from sessionStorage or use default
  const selectedStoryId = sessionStorage.getItem('selectedStory') || storiesData.defaultStory;
  const currentStory = storiesData.stories[selectedStoryId];
  
  // Debug logging
  console.log('storiesData:', storiesData);
  console.log('selectedStoryId:', selectedStoryId);
  console.log('currentStory:', currentStory);


  const handleRecapToggle = () => {
    setShowRecap(prev => !prev);
  };

  const handleContinueInvestigation = () => {
    // Navigate to Messages page when continuing investigation
    navigate('/messages');
  };

  // Calculate player progress from timeline data
  useEffect(() => {
    if (timelineData && timelineData.timeline) {
      const totalDays = timelineData.timeline.length;
      
      // For demo purposes, we'll simulate progress
      // In a real app, this would come from saved game state
      const currentDay = 1; // Player is on day 1
      const completedDays = currentDay;
      const completionPercentage = Math.round((completedDays / totalDays) * 100);
      
      // Determine current status based on progress
      let currentStatus = 'Case Opened';
      if (completionPercentage >= 100) {
        currentStatus = 'Case Closed';
      } else if (completionPercentage >= 75) {
        currentStatus = 'Final Review';
      } else if (completionPercentage >= 50) {
        currentStatus = 'Deep Investigation';
      } else if (completionPercentage >= 25) {
        currentStatus = 'Initial Investigation';
      }
      
      setPlayerProgress({
        currentDay,
        completionPercentage,
        totalDays,
        currentStatus
      });
    }
  }, []);



  return (
    <div className="home-container">
      
      {/* Debug info */}
      {console.log('Home component rendering, currentStory:', currentStory)}
      {console.log('coverImage path:', currentStory?.coverImage)}
      
      {/* Book Cover Style Case File */}
      <div className="home-cover">
        <div 
          className="cover-background"
          style={{
            backgroundImage: `url(${currentStory.coverImage})`,
            backgroundSize: 'cover',
            backgroundPosition: 'center',
            backgroundRepeat: 'no-repeat',
            backgroundColor: '#8B0000' // Fallback color to make it visible
          }}
        >

          
          <div className="cover-overlay"></div>
          
          {/* Smoky Animated Overlay */}
          <div className="smoke-overlay">
            <div className="smoke-layer smoke-1"></div>
            <div className="smoke-layer smoke-2"></div>
            <div className="smoke-layer smoke-3"></div>
            <div className="smoke-layer smoke-4"></div>
            <div className="smoke-layer smoke-5"></div>
            <div className="smoke-layer smoke-6"></div>
          </div>
        </div>
        
        <div className="cover-content">
          {/* Top Header - Like "WELCOME TO CRYSTAL LAKE" */}
          <div className="cover-header">
            <h2>{currentStory.basedOn}</h2>
            <p>{currentStory.description}</p>
          </div>
          
          {/* Main Title - Like "FRIDAY THE 13TH" */}
          <div className="main-title">
            <h1>{currentStory.title}</h1>
            <div className="case-subtitle">{currentStory.subtitle}</div>
          </div>
          
          {/* Bottom Action Area - Like Credits Block */}
          <div className="cover-actions">
            <button 
              className="recap-btn"
              onClick={handleRecapToggle}
            >
              {showRecap ? 'HIDE RECAP' : 'STORY SO FAR'}
            </button>
            <button 
              className="continue-btn"
              onClick={handleContinueInvestigation}
            >
              CONTINUE INVESTIGATION
            </button>
          </div>
          
          {/* Bottom Footer - Book Synopsis */}
          <div className="cover-footer">
            <p className="synopsis-text">
              {currentStory.synopsis}
            </p>
          </div>
        </div>
      </div>

      {/* Story Slideshow */}
      <StorySlideshow 
        isOpen={showRecap} 
        onClose={() => setShowRecap(false)} 
      />
      
      {/* Bottom Navigation - Hidden on home page */}
      <BottomNavigation showNavigation={false} />
    </div>
  );
}

export default Home;
